module.exports = __webpack_public_path__ + "img/icon_chengjiu@2x.1c6d541f.png";